import { render, staticRenderFns } from "./TenantPhone.vue?vue&type=template&id=4f559b7e&"
import script from "./TenantPhone.vue?vue&type=script&lang=js&"
export * from "./TenantPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports